import script from "./ButtonLinkNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonLinkNavigation.vue?vue&type=script&setup=true&lang=js"

import "./ButtonLinkNavigation.vue?vue&type=style&index=0&id=4df74b1a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4df74b1a"]])

export default __exports__